import { Text, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import { View } from 'react-native'
import { PressableOpacity } from 'shared/components/pressable_opacity'
import { Rating } from 'shared/components/rating'
import { DEFAULT_RATING, RatingSubViewProps } from '../queries/shared/types'

const STORE_REVIEWS = [
  t('badShiftReview'),
  t('badShiftReview'),
  t('okayShiftReview'),
  t('goodShiftReview'),
  t('greatShiftReview'),
]

export function StoreRatingView({
  shift,
  onPressCloseButton,
  onChangeRating,
}: RatingSubViewProps) {
  const styles = useStyles()
  const store = shift?.store

  return (
    <View style={styles.container}>
      <View style={styles.removeButtonContainer}>
        <PressableOpacity
          style={styles.removeButton}
          onPress={onPressCloseButton}
        >
          <Text style={styles.removeButtonText}>X</Text>
        </PressableOpacity>
      </View>
      <Text style={styles.heading}>
        {t('storeRatingTitle', { store: shift?.store.name })}
      </Text>
      <Text style={styles.shiftCompletionDescription}>
        {t('storeRatingDescription', {
          date: shift?.date,
          time: shift?.endTime,
        })}
      </Text>
      <Rating
        count={5}
        defaultRating={DEFAULT_RATING}
        size={25}
        reviews={STORE_REVIEWS}
        onFinishRating={rating => onChangeRating(rating)}
      />
    </View>
  )
}

const useStyles = makeStyles((theme, darkMode) => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors?.white,
    borderTopWidth: 2,
    borderTopColor: theme.colors?.grey2,
  },
  removeButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  removeButton: {
    marginRight: 20,
    marginTop: 10,
    backgroundColor: theme.colors?.grey3,
    width: 20,
    height: 20,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  removeButtonText: {
    fontSize: 10,
    fontFamily: font.bold,
    color: theme.colors?.white,
  },
  heading: {
    textAlign: 'center',
    fontSize: 20,
    margin: 15,
    fontFamily: font.bold,
    paddingTop: 10,
    color: theme.colors.black,
  },
  shiftCompletionDescription: {
    textAlign: 'center',
    fontSize: 16,
    margin: 15,
    fontFamily: font.normal,
    color: theme.colors?.black,
  },
}))
